import { useMemo } from 'react';

const useFiltersDisableSettings = (
  filters: $TSFixMe,
  {
    dateRange = false,
    budget = false,
    flightType = false,
    travelClass = false,
    travelerInterest = false,
    flightStopCount = false
  }
) => {
  const daterangeDisableSettings = useMemo(() => {
    return dateRange
      ? {
          dateRangeSettings: {
            ...filters.dateRangeSettings,
            disabled: true,
            inputItem: { ...filters.dateRangeSettings.inputItem, disabled: true }
          },
          dateRangeColumnSettings: {
            ...filters.dateRangeColumnSettings,
            className: 'filterColumn'
          }
        }
      : {};
  }, [dateRange, filters.dateRangeColumnSettings, filters.dateRangeSettings]);

  const budgetDisableSettings = useMemo(() => {
    return budget
      ? {
          budgetSettings: {
            ...filters.budgetSettings,
            disabled: true
          },
          budgetColumnSettings: {
            ...filters.budgetColumnSettings,
            className: 'filterColumn'
          }
        }
      : {};
  }, [budget, filters.budgetColumnSettings, filters.budgetSettings]);

  const flightTypeDisableSettings = useMemo(() => {
    return flightType
      ? {
          flightTypeSettings: {
            ...filters.flightTypeSettings,
            disabled: true
          }
        }
      : {};
  }, [filters.flightTypeSettings, flightType]);

  const travelClassDisableSettings = useMemo(() => {
    return travelClass
      ? {
          travelClassSettings: {
            ...filters.travelClassSettings,
            disabled: true
          }
        }
      : {};
  }, [filters.travelClassSettings, travelClass]);

  const travelerInterestDisableSettings = useMemo(() => {
    if (filters.travelerInterestSettings) {
      const travelerInterestSettings = {};
      Object.keys(filters.travelerInterestSettings).forEach((key) => {
        filters.travelerInterestSettings[key] = {
          ...filters.travelerInterestSettings[key],
          disabled: travelerInterest
        };
      });
      return travelerInterestSettings;
    }
    return {};
  }, [filters.travelerInterestSettings, travelerInterest]);

  const flightStopCountDisableSettings = useMemo(() => {
    return flightStopCount
      ? {
          flightStopCountSettings: {
            ...filters.flightStopCountSettings,
            disabled: true
          }
        }
      : {};
  }, [filters.flightStopCountSettings, flightStopCount]);

  const filtersDisableSettings = useMemo(() => {
    return {
      ...daterangeDisableSettings,
      ...budgetDisableSettings,
      ...flightTypeDisableSettings,
      ...travelClassDisableSettings,
      ...travelerInterestDisableSettings,
      ...flightStopCountDisableSettings
    };
  }, [
    budgetDisableSettings,
    daterangeDisableSettings,
    flightTypeDisableSettings,
    travelClassDisableSettings,
    travelerInterestDisableSettings,
    flightStopCountDisableSettings
  ]);

  return filtersDisableSettings;
};

export default useFiltersDisableSettings;
